import React, { FunctionComponent, MouseEvent } from 'react';
import SimpleButton from '../../../../../common/components/presentation/simpleButton/SimpleButton';
import { IButtonProps } from '../ActionButtons';
import actionButtonsStyles from '../ActionButtonsStyles';
import { Box, Typography } from '@material-ui/core';
import Translation from '../../../../../common/components/translation/Translation';
import useWidgetContext from '../../../../../common/react/useWidgetContext';
import checkoutDataLayerRest from '../../../../../common/utils/dataLayer/rest/checkoutDataLayerRest';

type ISubmitProps = IButtonProps & { disabled: boolean };

const Submit: FunctionComponent<ISubmitProps> = ({ onClick, disabled }) => {
  const styles = actionButtonsStyles();
  const {
    configuration: { dimensions },
  } = useWidgetContext();
  const customiseSummarySubmitHandler = (args?: MouseEvent<HTMLButtonElement>) => {
    onClick(args);
    checkoutDataLayerRest(dimensions);
  };

  return (
    <Box className={styles.item}>
      <SimpleButton
        type="filled"
        dataTest="customise:summary:submit"
        action={customiseSummarySubmitHandler}
        disabled={disabled}
      >
        <Typography variant="caption">
          <Translation id={'spc.customise.button.order'} />
        </Typography>
      </SimpleButton>
    </Box>
  );
};

export default Submit;
